module.exports = __webpack_public_path__ + "img/cedula.1e228c59.png";